<template>
  <div class="list-content">
    <div class="list-content-info">
      <div class="list-content-info-l">
        <div style="line-height:50px;font-weight:bold;color:#1a1a1a;background-color:#fafafa;">
          活动
        </div>
        <div style="height:821px;overflow:auto" v-if="actList.items && actList.items.length">
          <Row v-for="(item,index) in actList.items" :key="index" class="row-title" :class="{rowtitle:index==current}" @click.native="getApplyId(item,index)">
            <Col style="height: 30%">{{ item.name }}</Col>
            <Col style="height: 30%;font-size: 12px;color:#f00;" v-if="!item.isReg">未开启报名</Col>
            <template v-else> 
              <Col 
              style="height: 30%;font-size: 12px;color:blue;" 
              v-if="new Date().getTime() < new Date(item.regStart).getTime()">
              报名于{{ new Date(item.regStart).getFullYear() }}/{{ (new Date(item.regStart).getMonth() + 1) }}/{{ new Date(item.regStart).getDate() }}开启   
              </Col>
               <Col style="height: 30%;font-size: 12px;color:#b5b5b5" v-if="new Date().getTime() > new Date(item.regEnd).getTime()">报名截止于{{ new Date(item.regEnd).getFullYear() }}/{{ (new Date(item.regEnd).getMonth() + 1) }}/{{ new Date(item.regEnd).getDate() }}</Col>
              <Col style="height: 30%;font-size: 12px;color:#ffb200;" v-if="(new Date(item.regStart).getTime() < new Date().getTime()) && (new Date(item.regEnd).getTime() > new Date().getTime())">剩余: {{ item.regEnd | time_sort }}</Col>
            </template>
            <Col style="height: 30%">共 {{ item.regCount }} 条申请记录</Col>
          </Row>
        </div>
        <div v-else style="text-align:center;margin-top:50px;">暂无活动</div>
      </div>
      <div class="list-content-info-r">
        <Row style="text-align:center;height:50px;line-height:50px;color:#1a1a1a;font-weight:bold;padding-left:30px;background-color:#fafafa;">
          <Col span="4">姓名</Col>
          <Col span="3">手机</Col>
          <Col span="5">公司</Col>
          <Col span="6">地址</Col>
          <Col span="3">费用</Col>
          <Col span="3">支付状态</Col>
        </Row>
        <Row v-if="applyList.items && applyList.items.length">
          <div style="height:690px;overflow:auto;margin-left:30px">
            <div class="info-list" v-for="(item,index) in applyList.items" :key="index">
                <Row style="text-align:center;height:60px;display:flex;align-items:center">
                  <Col span="4">
                    {{ item.name }}
                  </Col>
                  <Col span="3">
                    {{ item.mob }}
                  </Col>
                  <Col span="5">
                    {{ item.company }}
                  </Col>
                  <Col span="6">
                    {{ item.address }}
                  </Col>
                  <Col span="3">
                    {{ item.money }}.00元
                  </Col>
                  <Col span="3" :class="item.isPay === true ? 's1' : ''">
                    {{ item.payStatus }}
                  </Col>
                </Row>
            </div>
          </div>
          <div class="my-page" v-if="totalCount > pageSize">
            <Page
              show-total
              show-elevator
              :page-size="pageSize"
              :current="pageIndex"
              :total="totalCount"
              @on-change="changePage"
              @on-page-size-change="changePageSize"
            />
          </div>
        </Row>
        <div v-else style="text-align:center;margin-top:50px;">暂无用户报名</div>
        <div class="total">已报名 {{ regNum }} / {{ regCountMax }} 人</div>
        <div class="price">总计 : {{ totalPrice }}元</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default { // 活动名单
  name:  'exhibition-activity-list',
  data() {
    return {
      actList: "",
      applyList: "",
      applyId: "",
      regCount: "",
      regCountMax: "",
      regNum: "",
      timer: "",
      totalPrice: 0,
      current: 0,
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      user: "getUser",
    })
  },
  methods: {
    ...mapActions({
      getActivity: "activityModule/getActivity",
      getActivityRes: "activityModule/getActivityRes",
    }),
    getApplyId(id,index) {
      this.applyId = id.id;
      this.current = index;
      this.totalPrice = 0;
      this.init();
    },
    // exportInfo() {
    //   if (!(this.applyList.items && this.applyList.items.length)) {
    //     return;
    //   }
    //   const exData = this.transformData(this.applyList.items);
    //   require.ensure([], () => {
    //     const {
    //       export_json_to_excel
    //     } = require("../../../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
    //     const tHeader = ["姓名", "手机", "公司","地址", "费用", "支付状态"]; //这个是表头名称 可以是iveiw表格中表头属性的title的数组
    //     const filterVal = ["name", "mob", "company", "address", "money", "payStatus"]; //与表格数据配合 可以是iview表格中的key的数组
    //     const data = this.formatJson(filterVal, exData);
    //     export_json_to_excel(tHeader, data, "活动名单"); //列表excel  这个是导出表单的名称
    //   });
    // },
    async init() {
      let actList1 = await this.getActivity({"CompId":this.company.id});
      let actTotalCount = actList1.totalCount;
      this.actList = await this.getActivity({"CompId":this.company.id, "pageSize": actTotalCount});

      // 按照报名时间排序
      this.getTime(this.actList.items);
      let arr1 = this.actList.items.filter(a => {
        return a.regEnd > new Date().getTime();
      });
      arr1.sort(this.sortNum2);
      let arr2 = this.actList.items.filter(a => {
        return a.regEnd <= new Date().getTime();
      });
      this.actList.items = arr1.concat(arr2);
      if (this.actList && this.actList.items && this.actList.items.length === 0) return;

      // 报名列表
      let option = {
        By: this.applyId || this.actList.items[0].id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      }
      this.applyList = await this.getActivityRes(option);
      if (this.applyList.items) {
        this.pageSize = this.applyList.pageSize;
        this.pageIndex = this.applyList.pageIndex;
        this.totalCount = this.applyList.totalCount;
      }

      let resInfo = await this.myFilter(this.actList.items, this.applyId || this.actList.items[0].id);
      if (resInfo[0].regCountMax === 0) {
        this.regCountMax = "不限";
      } else {
        this.regCountMax = resInfo[0].regCountMax;
      }
      this.cutTime(this.actList.items)
      
      this.regNum = this.applyList.items.length;
      this.applyList.items.map(a => {
        this.totalPrice += Number(a.money);
        if (a.isPay === true ) {
          a.payStatus = "已完成";
        } else {
          a.payStatus = "未完成";
        }
      })
    },
    sortNum2(a,b) {
      return a.regEnd - b.regEnd
    },
    getTime(arr) {
      function sortNum1(a,b) {
        return b.regEnd - a.regEnd
      }
      arr.map(a => {
        a.regEnd = new Date(a.regEnd).getTime();
      });
      return arr.sort(sortNum1)
    },
    myFilter(arr,id) {
      return  arr.filter((ele) =>
        ele.id === id
      );
    },
    myFilter2(arr,id) {
      return  arr.filter((ele) =>
        ele.actId === id
      );
    },
    transformData(data) {
      // 转换数据
      let arr = [];
      data.forEach(c => {
        arr.push({
          name: c.name,
          mob: c.mob,
          company: c.company,
          address: c.address,
          money: c.money,
          payStatus: c.payStatus,
        });
      });
      return arr;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    cutTime(arr) {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        arr.map(c => {
          let last = new Date(c.regEnd).getTime() - 100;
          if (new Date(c.regEnd).getTime() > new Date().getTime() ) {
            c.regEnd = last;
          } else {
            c.regEnd = c.regEnd
          }
        });
      }, 1000);
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped lang="scss">
.list-content {
  min-width: 800px;
  background-color: #f0f2f5;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 30px 30px 0 30px;
  &-info {
    width: 100%;
    height: 871px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 0px rgba(146, 160, 185, 0.2);
    padding-right: 30px;
    display: flex;
    &-l {
      width:230px;
      text-align: center;
    }
    &-r {
      flex:1;
      position: relative;
    }
    .row-title {
      background-color:#f2f2f2;
      border-bottom:1px solid #e8e8e8;
      padding: 10px 0 10px 15px;
      text-align: left;
      &:hover {
        background-color: #fff;
        cursor: pointer;
      }
    }
    .rowtitle {
      background-color:#fff;
      border-bottom:1px solid #e8e8e8;
      padding: 10px 0 10px 15px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.total {
  position: absolute;
  height: 55px;
  bottom: 0;
  left: 8%;
  line-height: 50px;
}
.price {
  position: absolute;
  height: 55px;
  bottom: 0;
  right: 14%;
  line-height: 50px;
}
.info-time {
  font-size: 12px;
  color: #ffb200;
}
.info-list {
  height: 60px;
  border-bottom: 1px solid #e8e8e8;
  &:hover {
    background-color: #f2f2f2;
  }
}
.s1 {
  color: #27d983;
}
.my-page {
  height: 80px;
  padding: 25px 0 0 50px;
}
</style>
